export const MOBILE_BOTTOM_BAR_HIGHT = 56
